import { React } from "react";
import { Box, Center, Text } from "@mantine/core";
import { Trans, useTranslation } from "react-i18next";
import { useMediaQuery } from "@mantine/hooks";
import { boldText } from "../../utils/textStyling";
import "./NotificationBanner.scss";

export const NotificationBanner = ({message}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 1415px)", true, {
    getInitialValueInEffect: false,
  });

  return (
    <>
        <Box p="md" className="notificationBanner" h={isMobile? 93 : 65}>
          <Center h="100%">
            <Text ff={"Montserrat"} fw={550} ta="center" c="white" size={isMobile ? "sm" :"lg"} >
            <Trans
                i18nKey={message}
                t={t}
                values={{ boldText }}
                components={{
                  bold: boldText(message),
                }}
              />
            </Text>
          </Center>
        </Box>
    </>
  );
};
